import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { Baseproperties } from "src/app/views/utility/baseproperties";
import { Router } from "@angular/router";
import { Regions } from "../../utility/modals";

@Injectable({
  providedIn: 'root'
})
export class RegionService {

  
  baseproperties: Baseproperties = new Baseproperties(); 

    private baseURL = this.baseproperties.gatewayBaseURL+"/common"
    scrollHeight: string = '22em'; 
    constructor(private httpClient: HttpClient,private route:Router) { }
    //DepartmentService
  
  getOptionDropdown(length):Array<any>{
    let options=[]
    let pairSize = 10;
    let numberOfPairs = Math.ceil(length / pairSize);   // Calculate the number of pairs
    let pairsArray = Array.from({ length: numberOfPairs }, (_, index) => {
      const end = Math.min((index + 1) * pairSize, length); // Create the array of pairs
      return [end];
    });
    pairsArray.map((e)=>{
      options.push({'label':e[0],value:e[0]})
    });
    return options
  }
  
  //Add New Regions
  addRegion(region): Observable<Object>{
    return this.httpClient.post(`${this.baseURL}/gen/addregion`, region);
  }
  getRegionById(id: number, number: any): Observable<Regions>{
    return this.httpClient.get<Regions>(`${this.baseURL}/gen/getregionbyid/${id}`);
  }
  updateRegion(region: Regions): Observable<Object>{
    return this.httpClient.post(`${this.baseURL}/gen/modifyregion`, region);
    }
    getRegionData(): Observable<any> {
        return this.httpClient.get(`${this.baseURL}/gen/viewregion`);
      }
      regionDataExcel()
  {
    
     return this.httpClient.get(`${this.baseURL}/gen/regiondataexcel`,{ responseType: 'blob' }); 
  }
}


